<template>
	<v-text-field
		v-model="amount"
		:label="(label in $vuetify.lang.locales.en ? $vuetify.lang.t(`$vuetify.${label}`) : label ) | capitalize"
		:suffix="suffix"
		type="number"
		hide-spin-buttons
		:rules="rules"
		:outlined="outlined"
		:dense="dense"
		:clearable="clearable"
		:hide-details="hideDetails"
	>
		<template v-slot:append>
			<v-menu offset-y>
				<template v-slot:activator="{ on, attrs }">
					<v-btn text v-bind="attrs" v-on="on">
						{{ curr.code }}
					</v-btn>
				</template>
				<v-list>
					<v-list-item v-for="(item, index) in currencies" :key="index" @click="curr=item">
						<v-list-item-icon>
							<v-icon v-text="item.icon" :color="item.color"></v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title v-text="item.name"></v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</template>
	</v-text-field>
</template>

<script>
export default {
	data: () => ({
		//loading: false,
	}),

	props: {
		value: 			{ type: [String, Number], default: null},
		currency: 		{ type: Object, default: () => {} },
		currencies: 	{ type: Array, default: () => [] },
		label:  		{ type: String, default: 'color'},
		placeholder:  	{ type: String, default: null},
		filled:  		{ type: Boolean, default: false},
		rounded:  		{ type: Boolean, default: false},
		outlined: 		{ type: Boolean, default: false },
		dense:  		{ type: Boolean, default: false},
		singleLine:  	{ type: Boolean, default: false},
		hideDetails: 	{ type: [Boolean,String], default: false },
		clearable:  	{ type: Boolean, default: false},
		suffix: 		{ type: String, default: null},
		rules:			{ type: Array, default: () => [] },			// Правила
	},

	computed: {
		amount: {
			get() 		{ return this.value },
			set(val) 	{ this.$emit('input', val) }
		},
		curr: {
			get() 		{ return this.currency },
			set(val) 	{ this.$emit('currency', val) }
		},
	},
}
</script>